import { createResourceStore } from "@/lib/resource";
import type { Asset } from "./Asset";
import type { Category } from "./Category";
import type { Price } from "./Price";
import type { Shop } from "./Shop";

export interface Service {
  __type: "Service";
  id: string;
  name: string;
  description: string | null;
  featured_image_id: string | null;
  category_id: string | null;
  shop_id: string;

  // Price pointers
  current_price_id: string | null;
  selling_price: number;
  unit_price: number;

  // Relations
  category?: Category;
  shop?: Shop;
  featured_image?: Asset;
  current_price?: Price;
  prices?: Price[]; // All historical prices
  images: Asset[];

  // Auditing
  created_by: string | null;
  updated_by: string | null;
  created_at: string;
  updated_at: string;
}

export const useService = createResourceStore<Service>("services", () => ({
  stats: {
    filters: {
      start_date: "",
      end_date: "",
    },
    period: [],
    total_services_sold: 0,
    top_services: [],
    top_categories: [],
    total_revenue: 0,
    series: [],
  },
  transform: (item: Service) => {
    return {
      ...item,
      __type: "Service",
    };
  },
}));
